import { render } from "./px-information-card.vue?vue&type=template&id=6b6a7dc2&scoped=true&ts=true"
import script from "./px-information-card.vue?vue&type=script&lang=ts"
export * from "./px-information-card.vue?vue&type=script&lang=ts"

import "./px-information-card.vue?vue&type=style&index=0&id=6b6a7dc2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b6a7dc2"]])

export default __exports__